<div class="flashcard-page-container" *ngIf="!loading && items.length">
  <div class="flashcard-controls">
    <button mat-icon-button [disabled]="currentIndex === 0" (click)="prevCard()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span>{{ currentIndex + 1 }} / {{ items.length }}</span>
    <button mat-icon-button [disabled]="currentIndex === items.length - 1" (click)="nextCard()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  <div class="flashcard-wrapper">
    <ddc-flash-card
      [data]="items[currentIndex]"
      [isFlipped]="isFlipped"
      [type]="type === 'words' ? 'word' : 'pair'"
      (cardClick)="onCardClick()"
    ></ddc-flash-card>
  </div>
</div>
@if (loading) {
  <ddc-loading-skeleton></ddc-loading-skeleton>
}
<div *ngIf="error">{{ error }}</div>
